import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  IconButton,
  Chip,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  content: {
    paddingBottom: theme.spacing(1),
  },
  title: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  status: {
    marginRight: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 0,
  },
}));

export const AusumConfigCard = ({
  title,
  description,
  status,
  onEdit,
  onDelete,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <Typography className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.description} variant="body2">
          {description}
        </Typography>
        <Chip
          size="small"
          label={status}
          color="primary"
          className={classes.status}
        />
      </CardContent>
      <CardActions className={classes.actions}>
        <IconButton size="small" onClick={onEdit} aria-label="edit">
          <EditIcon />
        </IconButton>
        <IconButton size="small" onClick={onDelete} aria-label="delete">
          <DeleteIcon />
        </IconButton>
      </CardActions>
    </Card>
  );
};
